export enum LDFeatureFlags {
  CancelReservation = 'feature.gx.guest-portal-cancel-reservation',
  OcrDocumentScanner = 'feature.gx.ocr-document-scanner',
}
